import React from 'react';
import $ from 'jquery';
import { BaseContext, ConversationContext } from '../contexts/baseContext';
import EmojiTable from './emojiTable';

class MessageEditor extends React.Component {
  static contextType = BaseContext;

  constructor() {
    super();

    this.contentEditable = React.createRef();
    this.state = {
      showEmoji: "hidden",
      message: "",
      editableInput: "none"
    };
  }

  componentDidMount() {
    $(document).ready(function() {
      $(".message-editor").focus();
    });
  }

  handleShowEmoji = (value = null) => {
    let isShow = false;

    if (value !== null) {
      if (value === "hidden") {
        this.setState({ showEmoji: "hidden", editableInput: "text"});
      } else {
        isShow = true;
        this.setState({ showEmoji: "", editableInput: "none"});
      }
    } else {
      this.setState({ showEmoji: value });

      if (value === "hidden")
        isShow = false;
      else
        isShow = true
    }

    this.props.conversationResize(isShow);
    this.manageKeybord();
  }

  handleAddEmojiOrSpace = (emoji) => {

    const updateMessage = (message) => {
      this.setState({ message, editableInput: "none" });
    }

    $(document).ready(function() {
      let messageEditor = document.querySelector('.message-editor');

      console.log(messageEditor.selectionStart);
      messageEditor.setRangeText(`${emoji}`, messageEditor.selectionStart, messageEditor.selectionEnd, "end");

      updateMessage(messageEditor.value);

      messageEditor.focus();
    });

  }

  handleFocus = (event) => {
    $(document).ready(function() {
      let messageEditor = $(".message-editor");

      let id = setTimeout(() => {
        messageEditor.focus();
        clearInterval(id);
      }, 50);

      event.preventDefault();
    });
  }

  handleChangeMessage = (event) => {
    const message = event.target.value;

    this.setState({ message });
  }

  handleSendMessage = (e, sendMessage, idMessageIndexed) => {
    e.preventDefault();

    const message = this.state.message;

    // this.handleShowEmoji("hidden");

    if (this.state.showEmoji === "hidden") {
      this.setState({ message: "", editableInput: "text"});
    } else {
      this.setState({ message: "", editableInput: "none"});
    }

    sendMessage(message, idMessageIndexed);

    $(function() {
      let messageEditor = document.querySelector(".message-editor");
      messageEditor.focus();
    });
  }

  // this function handle the visibility of the mobile keyboard
  manageKeybord = () => {
    const emojiShown = this.state.showEmoji;
    const handleKeyboard = (value) => {
      this.setState({ editableInput: value })
    }

    $(function() {
      let messageEditor = document.querySelector(".message-editor");
      messageEditor.focus();

      if (emojiShown === "hidden") {
        handleKeyboard("text");
      } else {
        handleKeyboard("none");
      }
    });
  }

  generateMessageIndexedInfo = (idMessage) => {
    let { messages, nameContact } = this.props;

    if (idMessage !== null) {
      let message = messages.find(msg => msg.id === idMessage);

      if (message !== undefined) {
        let author = message.type === "sended" ? "You" : nameContact;
        let content = message.content;

        return { author, content };
      }
    }

    return null;
  }

  render() {
    const { messageEditorPositionBottom, sendMessage } = this.context;

    return (
      <>
        <ConversationContext.Consumer>
          {
            ({ idMessageIndexed, setIdMessageIndexed }) => {

              let msg = idMessageIndexed !== null ? this.generateMessageIndexedInfo(idMessageIndexed) : null;

              return (
                <>
                  <div className="section-conversation-footer" style={{ bottom: `${messageEditorPositionBottom}px` }}>

                    {
                      msg !== null && (
                        <div className="message-indexed">
                          <div className="message-indexed--content">
                            <span>{ msg.author }</span>
                            <span className="text-muted">
                              { msg.content }
                            </span>
                          </div>
                          <span className="close-message-indexed" onClick={() => setIdMessageIndexed(null)}>&times;</span>
                        </div>
                      )
                    }

                    <div className="editor input-group">
                      <div>
                        <form onSubmit={(e) => this.handleSendMessage(e, sendMessage, idMessageIndexed)}>
                          <input
                            value={this.state.message}
                            onChange={this.handleChangeMessage}
                            onClick={() => this.manageKeybord()}
                            type="text"
                            placeholder="type a message..."
                            className="message-editor"
                            inputMode={this.state.editableInput}
                          />
                        </form>
                      </div>
                      <div>
                        {
                          this.state.showEmoji === "hidden" ? (
                            <i className="bi bi-emoji-smile" onClick={() => this.handleShowEmoji("show")}></i>
                          ) : (
                            <i className="bi bi-keyboard" onClick={() => this.handleShowEmoji("hidden")}></i>
                          )
                        }
                        <i
                          className={`bi bi-cursor-fill message-send ${this.state.message.length === 0 && "message-send--disable"}`}
                          onClick={(e) => {
                            setIdMessageIndexed(null);
                            this.handleSendMessage(e, sendMessage, idMessageIndexed)
                          }}
                        >
                        </i>
                      </div>
                    </div>
                  </div>

                  <EmojiTable
                    onAddEmojiOrSpace={this.handleAddEmojiOrSpace}
                    showEmoji={this.state.showEmoji}
                  />
                </>
              )
            }
          }
        </ConversationContext.Consumer>
      </>
    );
  }

}

export default MessageEditor;
